import mitt from "mitt";
import type { SectorEvent } from "~/modules/sector/models/SectorEvent.interface";

type Events = {
  sector: SectorEvent;
};

export const eventBus = mitt<Events>();
